var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardListSolidLargeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.86023C11.055 1.86023 10.3876 2.52773 10.0576 3.36023H3.75V22.1102H20.25V3.36023H13.9424C13.6124 2.52773 12.945 1.86023 12 1.86023ZM12 3.36023C12.4125 3.36023 12.75 3.69773 12.75 4.11023V4.86023H15V6.36023H9V4.86023H11.25V4.11023C11.25 3.69773 11.5875 3.36023 12 3.36023ZM5.25 4.86023H7.5V7.86023H16.5V4.86023H18.75V20.6102H5.25V4.86023ZM6.75 10.1102V11.6102H8.25V10.1102H6.75ZM9.75 10.1102V11.6102H17.25V10.1102H9.75ZM6.75 13.1102V14.6102H8.25V13.1102H6.75ZM9.75 13.1102V14.6102H17.25V13.1102H9.75ZM6.75 16.1102V17.6102H8.25V16.1102H6.75ZM9.75 16.1102V17.6102H17.25V16.1102H9.75Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardListSolidLargeIcon);
export default __webpack_public_path__ + "static/media/clipboardListSolidLargeIcon.fd521ebc93e6b5e48686f7e6e999d8fe.svg";
export { ForwardRef as ReactComponent };